export const personaCheckboxSelectMessageLabel = "uwIyjb";
export const personaCheckboxSelectConversationLabel = "a5ZBvc";
export default {personaCheckboxSelectMessageLabel,personaCheckboxSelectConversationLabel};